var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleErrorfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0Z",
    fill: "#F20800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2271 5.4841C10.3523 5.05198 10.6087 4.79352 11.061 4.64612C11.1357 4.62189 11.4386 4.60977 11.7354 4.61785C12.3392 4.634 12.6078 4.73294 12.8581 5.03179C13.1671 5.39727 13.1671 5.40131 13.1509 9.7467L13.1509 9.74754C13.1348 13.7246 13.1348 13.7266 13.0177 13.9467C12.8703 14.2233 12.5876 14.4737 12.319 14.5686C12.0525 14.6615 11.2569 14.6615 10.9904 14.5686C10.7218 14.4737 10.4391 14.2233 10.2917 13.9467C10.1746 13.7266 10.1746 13.7246 10.1584 9.74755L10.1584 9.7467C10.1463 6.29381 10.1544 5.73044 10.2271 5.4841Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2796 18.0578C10.4633 17.6964 10.8409 17.3713 11.2226 17.2461C11.4608 17.1674 12.0929 17.2259 12.3271 17.3471C12.5835 17.4803 12.8985 17.7994 13.0298 18.0578C13.1711 18.3405 13.1954 18.8514 13.0803 19.1947C12.8904 19.7702 12.2665 20.2144 11.6547 20.2144C11.0429 20.2144 10.4189 19.7702 10.2291 19.1947C10.114 18.8514 10.1382 18.3405 10.2796 18.0578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleErrorfilled);
export default __webpack_public_path__ + "static/media/Circle Error (filled).9a402a4ab7f8b9274bf70b398b744e01.svg";
export { ForwardRef as ReactComponent };